import {
  FETCH_LOAD_PROJECT_BY_ID_REQUEST,
  FETCH_LOAD_PROJECT_BY_ID_SUCCESS,
  FETCH_LOAD_PROJECT_BY_ID_FALUIRE,
} from './loadProjectByIDTypes'

const initialState = {
  loading: false,
  particularProjectInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOAD_PROJECT_BY_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_PROJECT_BY_ID_SUCCESS : return {
      ...state,
      particularProjectInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_PROJECT_BY_ID_FALUIRE : return {
      ...state,
      loading: false,
      particularProjectInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
